import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { ShareholderFundPositionModel } from "../model/domain/ShareholderFundPositionModel";
import { StockFixedIncome } from "../model/domain/StockFixedIncomeModel";
import { StockFunds } from "../model/domain/StockFundsModel";
import { StockVariableIncome } from "../model/domain/StockVariableIncomeModel";
import { AllStockModel } from "./../model/domain/AllStock";

@Injectable({
  providedIn: "root",
})
export class StockService {
  constructor(private http: HttpClient) {}

  getAllStock(fundSourceId: string): Observable<AllStockModel> {
    const params: any = {};
    params.fundSourceId = fundSourceId;

    return this.http.get<AllStockModel>(
      `${environment.apiUrls.tickets}/TicketStock/all-stock`,
      { params }
    );
  }

  getFundStock(fundSourceId: string): Observable<StockFunds> {
    const params: any = {};
    params.fundSourceId = fundSourceId;

    return this.http.get<StockFunds>(
      `${environment.apiUrls.tickets}/TicketStock/fund`,
      { params }
    );
  }

  getFixedIncomeStock(fundSourceId: string): Observable<StockFixedIncome> {
    const params: any = {};
    params.fundSourceId = fundSourceId;

    return this.http.get<StockFixedIncome>(
      `${environment.apiUrls.tickets}/TicketStock/fixed-income`,
      { params }
    );
  }

  getStockFixedIncomeCommitted(
    fundSourceId: string
  ): Observable<StockFixedIncome> {
    const params: any = {};
    params.fundSourceId = fundSourceId;

    return this.http.get<StockFixedIncome>(
      `${environment.apiUrls.tickets}/TicketStock/fixed-income-committed`,
      { params }
    );
  }

  getVariableIncomeStock(
    fundSourceId: string
  ): Observable<StockVariableIncome> {
    const params: any = {};
    params.fundSourceId = fundSourceId;

    return this.http.get<StockVariableIncome>(
      `${environment.apiUrls.tickets}/TicketStock/variable-income`,
      { params }
    );
  }

  getShareholderFundStock(
    shareholderSourceId: string
  ): Observable<ShareholderFundPositionModel> {
    return this.http.get<ShareholderFundPositionModel>(
      `${environment.apiUrls.tickets}/Shareholder/fund-position/${shareholderSourceId}`
    );
  }
}
